import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { supabase } from '@/integrations/supabase/client';

export const TelegramTestDialog = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { toast } = useToast();

  const testTelegram = async () => {
    setIsLoading(true);
    try {
      console.log('🧪 Testing Telegram bot...');
      
      const { data: result, error } = await supabase.functions.invoke('test-telegram-simple');
      
      console.log('Test result:', result);
      console.log('Test error:', error);
      
      if (error) {
        toast({
          title: "Telegram թեստը ձախողվեց",
          description: `Սխալ: ${error.message}`,
          variant: "destructive"
        });
      } else {
        toast({
          title: result?.success ? "Telegram թեստը հաջողվեց!" : "Telegram թեստը ձախողվեց",
          description: result?.success 
            ? "Հաղորդագրությունը հաջողությամբ ուղարկվեց Telegram-ին" 
            : `Սխալ: ${result?.result?.description || 'Unknown error'}`,
          variant: result?.success ? "default" : "destructive"
        });
      }
      
      setIsOpen(false);
    } catch (error: any) {
      console.error('Test error:', error);
      toast({
        title: "Սխալ",
        description: `Թեստը ձախողվեց: ${error.message}`,
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="text-sm">
          🧪 Telegram թեստ
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px] bg-card border-2 border-border/70">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-primary text-center">
            Telegram բոտի թեստ
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <p className="text-muted-foreground text-sm text-center">
            Սա կուղարկի թեստային հաղորդագրություն Telegram բոտին՝ ստուգելու համար արդյոք կապակցումը աշխատում է:
          </p>
          
          <Button 
            onClick={testTelegram}
            className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-foreground font-semibold py-3 rounded-lg transition-all duration-300" 
            disabled={isLoading}
          >
            {isLoading ? "Թեստավորում..." : "Ուղարկել թեստային հաղորդագրություն"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};